import Modal from '@Components/Shared/Modals/Modal';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const FirstTimeUserInstructionModal = (props) => {

    const onClose = () => {
        props?.onClose?.();
    };
    const currentSite = useRecoilValue(atoms.currentWebsite);

    return (
        <Modal containerClassName='first-time-user-instruction-modal' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
            </Modal.Header>
            <Modal.Body>
                <video controls autoPlay muted poster={props.VideoPosterURL} alt="First Time User Video">
                    <source src={props.FirstTimeUserVideoURL} type={props.VideoSourceType} />
                </video>
                <ThemedLinkButton variant='text' size='small' onClick={onClose} className="first-time-user-instruction__continue-btn"
                    sx={{textDecoration: 'underline', color: props.isDarkMode ? 'white' : 'black' }}>
                    {translator.translate('sandhills.tradepubwebsite.mvc.continueto', [currentSite.ProperDisplayDomainName])}
                </ThemedLinkButton>
            </Modal.Body>
        </Modal>
    );
};

export default FirstTimeUserInstructionModal;
